// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface CipNumberDataTableDTO extends EntitySelectorDTO { 
	id: string | null;
	display: string | null;
	title: string | null;
	cipNumberId: string | null;
	transferMajor: boolean;
	nonTransferMajor: boolean;
}

const CipNumberDataTableDTO = {
    className: 'CipNumberDataTableDTO',
    create: (initValues?: Partial<CipNumberDataTableDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: '00000000-0000-0000-0000-000000000000',
			display: "",
			title: "",
			cipNumberId: '00000000-0000-0000-0000-000000000000',
			transferMajor: false,
			nonTransferMajor: false,
        },
        initValues);
    },
	id: 'id',
	display: 'display',
	title: 'title',
	cipNumberId: 'cipNumberId',
	transferMajor: 'transferMajor',
	nonTransferMajor: 'nonTransferMajor',
};

export default CipNumberDataTableDTO;